<app-loader main [message]="'OVERVIEW.DIALOG.LOADING_DATA' | translate"></app-loader>
